import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'app-user-profile',
  standalone: false,
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css'
})
export class UserProfileComponent {
  changePassForm!: FormGroup;
  infoForm!: FormGroup;
  shareObject: any = {
    tab: 'info',
    options: {}
  }
  user: any;
  constructor(
    public sharedService: SharedService,
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService,
  ) { }
  ngOnInit(): void {
    this.shareObject.days = this.sharedService.env.timesheetDays;
    this.profile();
    this.attendanceHistory();
    this.getOthistory();
    this.getWorkCalendar();
    this.getRelocationHistory();
    this.getAbsenceHistory();
    this.getLeaveHistory();
    this.changePassForm = this.fb.group({
      // 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character
      current_password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/)]],
      new_password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/)]],
      confirm_password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/)]]
    });
    this.infoForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(6)]],
      phone: ['', [Validators.required, Validators.minLength(6)]],
      avatar: [''],
      email: ['', [Validators.required, Validators.email]],
    });
  }
  profile() {
    // this.shareObject.isLoading = true;
    this.sharedService.profile().subscribe({
      next: (res) => {
        console.log(res);
        if (res.success) {
          this.shareObject.isLoading = false;
          this.user = res.data;
          // this.infoForm.patchValue({
          //   name: res.user?.profile?.name,
          //   phone: res?.user?.profile?.phone,
          //   avatar: res.user?.profile?.avatar,
          //   email: res.user?.email,
          // });
        }
      },
      error: (err: any) => {
        console.error(err);
      },
      complete: () => {
        this.shareObject.isLoading = false;
      }
    });
  }
  changePassword() {
    // if(this.changePassForm.invalid) {
    //   this.sharedService.toast({
    //     title: this.translate.instant('toast_error'),
    //     message: this.translate.instant('toast_invalid_form'),
    //     type: 'danger'
    //   })
    //   return;
    // }
    this.shareObject.isLoading = true;
    this.changePassForm.disable();
    this.sharedService.callApi('/auth/update', this.changePassForm.value).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.sharedService.toast({
            message: this.translate.instant('toast_updated'),
            type: 'success'
          })
          this.changePassForm.reset();
        } else {
          switch (res.message) {
            case 'password_not_match':
              this.sharedService.toast({
                title: this.translate.instant('toast_update_failed'),
                message: this.translate.instant('toast_password_not_match'),
                type: 'danger'
              })
              break;
            case 'password_incorrect':
              this.sharedService.toast({
                title: this.translate.instant('toast_update_failed'),
                message: this.translate.instant('toast_password_incorrect'),
                type: 'danger'
              })
              break;
            default:
              this.sharedService.toast({
                title: this.translate.instant('toast_update_failed'),
                message: this.translate.instant('toast_update_user_failed'),
                type: 'danger'
              })
              break;
          }
        }
      },
      error: (err) => {
        switch (err.message) {
          case 'password_not_match':
            this.sharedService.toast({
              title: this.translate.instant('toast_update_failed'),
              message: this.translate.instant('toast_password_not_match'),
              type: 'danger'
            })
            break;
          case 'password_incorrect':
            this.sharedService.toast({
              title: this.translate.instant('toast_update_failed'),
              message: this.translate.instant('toast_password_incorrect'),
              type: 'danger'
            })
            break;
          default:
            this.sharedService.toast({
              title: this.translate.instant('toast_update_failed'),
              message: this.translate.instant('toast_update_user_failed'),
              type: 'danger'
            })
            break;
        }
      },
      complete: () => {
        this.shareObject.isLoading = false;
        this.changePassForm.enable();
      }
    })
  }
  updateInfo() {
    this.shareObject.isLoading = true;
    let profile = {
      name: this.infoForm.value.name,
      phone: this.infoForm.value.phone,
      avatar: this.infoForm.value.avatar,
    }
    this.sharedService.callApi('/auth/update', { profile }).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.sharedService.toast({
            title: this.translate.instant('toast_success'),
            message: this.translate.instant('toast_update_success'),
            type: 'success'
          })
        } else {
          this.sharedService.toast({
            title: this.translate.instant('toast_error'),
            message: this.translate.instant('toast_update_error'),
            type: 'danger'
          })
        }
      },
      error: (err) => {
        this.sharedService.toast({
          title: this.translate.instant('toast_error'),
          message: this.translate.instant('toast_update_error'),
          type: 'danger'
        })
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  changeTab(tab: string) {
    console.log(tab);
    this.shareObject.tab = tab;
  }
  selectAvatar(event: any) {
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {
      let img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        let canvas = document.createElement('canvas');
        canvas.width = 100;
        canvas.height = 100;
        let ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, 100, 100);
        let base64 = canvas.toDataURL('image/png');
        this.infoForm.patchValue({ avatar: base64 });
      };
    }
  }
  attendanceHistory() {
    this.sharedService.callApi('/users/list_attendance', {}).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.shareObject.attendances = res.data;
        } else {
          this.sharedService.toast({
            title: this.translate.instant('toast_error'),
            message: this.translate.instant('toast_cant_get_data'),
            type: 'danger'
          })
        }
      },
      error: (err) => {
        this.sharedService.toast({
          title: this.translate.instant('toast_error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'danger'
        })
      },
    });
  }
  getOthistory() {
    this.sharedService.callApi('/employee_overtime/get_request', {}).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.overtimes = res.data;
      }
    })
  }
  getRelocationHistory() {
    this.sharedService.callApi('/users/list_relocation', {}).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.relocations = res.data;
      }
    })
  }
  getAbsenceHistory() {
    this.sharedService.callApi('/users/list_absence', {}).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.absences = res.data;
      }
    })
  }
  getLeaveHistory() {
    this.sharedService.callApi('/users/list_leave', {}).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.leaves = res.data;
      }
    })
  }
  getWorkCalendar() {
    this.sharedService.callApi('/users/get_work_calendar', {}).subscribe({
      next: (res: any) => {
        if (res.success) {
          // this.shareObject.workCalendar = res.data;
          // this.shareObject.workCalendar.timesheet = this.shareObject.workCalendar.timesheet.map((day: any) => {
          //   day.workDays = day.workDays.map((d: any) => {
          //     d.dayText = this.shareObject.days.find((e: any) => d.day == e.day)?.name || '';
          //     return d;
          //   })
          //   return day;
          // })
          this.shareObject.workData = res.tableData.sort((a: any, b: any) => {
            return new Date(a.date).getTime() - new Date(b.date).getTime();
          });
          this.shareObject.workDataShift = res.tableData[0]?.shifts.map((s: any) => s.name);
          console.log(this.shareObject.workDataShift);
        } else {
          this.sharedService.toast({
            title: this.translate.instant('toast_error'),
            message: this.translate.instant('toast_cant_get_data'),
            type: 'danger'
          })
        }
      },
      error: (err) => {
        this.sharedService.toast({
          title: this.translate.instant('toast_error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'danger'
        })
      },
    });
  }
}
